import { render, staticRenderFns } from "./rewritelogs.vue?vue&type=template&id=60e84310&scoped=true&"
import script from "./rewritelogs.vue?vue&type=script&lang=js&"
export * from "./rewritelogs.vue?vue&type=script&lang=js&"
import style0 from "./rewritelogs.vue?vue&type=style&index=0&id=60e84310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e84310",
  null
  
)

export default component.exports